import React, { useEffect, useState } from 'react';
import { Field, FieldArray, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import { DynmicFormFieldTypeOptions } from '../../config/DynmicFormFieldType';
import dynamicFormService from '../../service/dynamicForm.service';
import AttendancePrefillEditor from './AttendancePrefillEditor';
import {
  InputUI,
  FormErrorUI,
  FormLabelUI,
  SelectUI,
  DialogUI,
  ButtonUI,
  CheckboxUI,
  AutoCompleteSelectUI,
} from '../Interface';
const DynamicFormCreatorDynFieldsDialog = (props) => {
  const { selectedIndex, open, onClose, viewField, selectedValuesState, remove } = props;
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const { selectedValues } = selectedValuesState;
  const [selectViewOptions, setSelectViewOptions] = useState([]);

  useEffect(() => {
    if (!open || selectViewOptions.length > 0) return;

    dynamicFormService.getSelectViews().then(setSelectViewOptions);
  }, [open, selectViewOptions.length]);

  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Mezők'} maxWidth="md" fullWidth>
      <Grid container spacing={2} sx={{ alignItems: 'center', mt: 1 }}>
        <Grid item xs={12} md={6}>
          <Field
            type="text"
            name={`dynamicFormField.[${selectedIndex}].name`}
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Megnevezés" />}
            variant="standard"
            helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.name} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.dynamicFormField?.[selectedIndex]?.name !== '' }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            name={`dynamicFormField.[${selectedIndex}].type`}
            component={SelectUI}
            fullWidth
            option={DynmicFormFieldTypeOptions}
            value={values?.dynamicFormField?.[selectedIndex]?.type ?? ''}
            variant="standard"
            onChange={(e) => {
              const value = e.target.value;
              setFieldValue(`dynamicFormField.[${selectedIndex}].type`, value ?? null).then(() => {
                validateField(`dynamicFormField.[${selectedIndex}].type`);
              });

              setFieldValue(`dynamicFormField.[${selectedIndex}].staticText`, '');
              if (value === 'STATIC') {
                setFieldValue(`dynamicFormField.[${selectedIndex}].required`, false);
              }
              if (value !== values.dynamicFormField?.[selectedIndex]?.type) {
                setFieldValue(`dynamicFormField.[${selectedIndex}].attendancePrefillTemplate`, '');
              }
              if (value !== 'COMBO') {
                setFieldValue(`dynamicFormField.[${selectedIndex}].dynamicFormFieldOption`, []);
                setFieldValue(`dynamicFormField.[${selectedIndex}].select`, '');
                setFieldValue(`dynamicFormField.[${selectedIndex}].autocomplete`, false);
                setFieldValue(`dynamicFormField.[${selectedIndex}].multiselect`, false);
                setFieldValue(`dynamicFormField.[${selectedIndex}].userIdMatch`, false);
              }
            }}
            label={<FormLabelUI text="Típus" />}
            helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.type} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.type !== '' || values.type !== null }}
          />
        </Grid>
        {/* statikus input box */}
        <Grid item xs={12} md={12}>
          {values?.dynamicFormField?.[selectedIndex]?.type === 'STATIC' && (
            <Field
              type="text"
              name={`dynamicFormField.[${selectedIndex}].staticText`}
              as={InputUI}
              fullWidth
              label={<FormLabelUI text="Statikus szöveg" />}
              variant="standard"
              helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.staticText} />}
              disabled={viewField}
              InputLabelProps={{ shrink: values.dynamicFormField?.[selectedIndex]?.staticText !== '' }}
              multiline
              rows={4}
            />
          )}
        </Grid>
        {values?.dynamicFormField?.[selectedIndex]?.type === 'COMBO' && (
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center" mb={2}>
              <Grid item xs={12}>
                <Field
                  type="autocomplete"
                  name={`dynamicFormField.[${selectedIndex}].select`}
                  component={AutoCompleteSelectUI}
                  fullWidth
                  label={<FormLabelUI text="Adatforrás view" />}
                  dataset={selectViewOptions}
                  selectedValue={values.dynamicFormField?.[selectedIndex]?.select ?? ''}
                  onChange={(_e, newValue) => {
                    setFieldValue(`dynamicFormField.[${selectedIndex}].select`, newValue?.value ?? '');
                    if (!newValue?.hasUserId) {
                      setFieldValue(`dynamicFormField.[${selectedIndex}].userIdMatch`, false);
                    }
                  }}
                  variant="standard"
                  helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.select} />}
                  disabled={viewField}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  name={`dynamicFormField.[${selectedIndex}].autocomplete`}
                  type="checkbox"
                  component={CheckboxUI}
                  checked={values.dynamicFormField?.[selectedIndex]?.autocomplete ?? false}
                  onChange={(e) =>
                    setFieldValue(`dynamicFormField.[${selectedIndex}].autocomplete`, e.target.checked)
                  }
                  label={<FormLabelUI text="Autocomplete" />}
                  disabled={viewField}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  name={`dynamicFormField.[${selectedIndex}].multiselect`}
                  type="checkbox"
                  component={CheckboxUI}
                  checked={values.dynamicFormField?.[selectedIndex]?.multiselect ?? false}
                  onChange={(e) => {
                    setFieldValue(`dynamicFormField.[${selectedIndex}].multiselect`, e.target.checked);
                    if (e.target.checked) {
                      setFieldValue(`dynamicFormField.[${selectedIndex}].autocomplete`, true);
                    }
                  }}
                  label={<FormLabelUI text="Több elem kiválasztása" />}
                  disabled={viewField}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  name={`dynamicFormField.[${selectedIndex}].userIdMatch`}
                  type="checkbox"
                  component={CheckboxUI}
                  checked={values.dynamicFormField?.[selectedIndex]?.userIdMatch ?? false}
                  onChange={(e) =>
                    setFieldValue(`dynamicFormField.[${selectedIndex}].userIdMatch`, e.target.checked)
                  }
                  label={<FormLabelUI text="Bejelentkezett felhasználó előtöltése" />}
                  disabled={
                    viewField ||
                    !values.dynamicFormField?.[selectedIndex]?.select?.startsWith('SELECT value, label, userId FROM ')
                  }
                />
              </Grid>
            </Grid>
            <Typography fontWeight={600} mb={1}>
              Választólista elemei
            </Typography>
            <FieldArray name={`dynamicFormField.[${selectedIndex}].dynamicFormFieldOption`}>
              {({ push, remove }) => (
                <Grid container spacing={2} alignItems="center">
                  {(values.dynamicFormField?.[selectedIndex]?.dynamicFormFieldOption || []).map((_option, optionIndex) => (
                    <React.Fragment key={optionIndex}>
                      <Grid item xs={10} md={10}>
                        <Field
                          type="text"
                          name={`dynamicFormField.[${selectedIndex}].dynamicFormFieldOption.[${optionIndex}].name`}
                          as={InputUI}
                          fullWidth
                          label={<FormLabelUI text="Megnevezés" />}
                          variant="standard"
                          helperText={
                            <FormErrorUI
                              message={
                                errors?.dynamicFormField?.[selectedIndex]?.dynamicFormFieldOption?.[optionIndex]?.name
                              }
                            />
                          }
                          disabled={viewField}
                        />
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <IconButton onClick={() => remove(optionIndex)} disabled={viewField} aria-label="Törlés">
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </React.Fragment>
                  ))}
                  <Grid item xs={12}>
                    <ButtonUI
                      text="Listaelem hozzáadása"
                      type="button"
                      onClick={() => push({ name: '' })}
                      disabled={viewField}
                    />
                  </Grid>
                </Grid>
              )}
            </FieldArray>
          </Grid>
        )}
        {values.worksheet &&
          !values.dynamicFormField?.[selectedIndex]?.systemRole &&
          !values.dynamicFormField?.[selectedIndex]?.onlyWithoutProject &&
          ['TEXT', 'LONG_TEXT', 'NUMBER', 'DECIMAL', 'DATE'].includes(values.dynamicFormField?.[selectedIndex]?.type) && (
            <Grid item xs={12}>
              <AttendancePrefillEditor index={selectedIndex} disabled={viewField} />
            </Grid>
          )}
        {values.dynamicFormField?.[selectedIndex]?.type !== 'STATIC' && (
          <Grid item xs={12}>
            <CheckboxUI
              label={<FormLabelUI text="Kötelező kitölteni" />}
              checked={values.dynamicFormField?.[selectedIndex]?.required ?? false}
              onChange={(event) =>
                setFieldValue(`dynamicFormField.[${selectedIndex}].required`, event.target.checked)
              }
              disabled={viewField}
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2} sx={{ px: 4, mt: 8, justifyContent: 'center' }}>
        <Grid item>
          <ButtonUI text="Mentés" className="bg-success" type="button" onClick={onClose} />
        </Grid>
        <Grid item>
          <ButtonUI
            text="Mégse"
            className=""
            color="blue-gray"
            type="button"
            variant="gradient"
            onClick={() => {
              const findedValue = selectedValues.dynamicFormField.find(
                (item) => item.id === values?.dynamicFormField[selectedIndex].id
              );

              if (findedValue) {
                setFieldValue(`dynamicFormField.[${selectedIndex}]`, findedValue);
                validateField(`dynamicFormField.[${selectedIndex}]`);
              } else {
                remove(selectedIndex);
              }
              onClose();
            }}
          />
        </Grid>
      </Grid>
    </DialogUI>
  );
};

export default DynamicFormCreatorDynFieldsDialog;
